export type Direction = 'up' | 'down'

export const numBoundary = (value: number, boundary: number, direction?: Direction) => {
  if (direction === 'up') {
    return Math.ceil(value / boundary) * boundary
  }
  if (direction === 'down') {
    return Math.floor(value / boundary) * boundary
  }
  return Math.round(value / boundary) * boundary
}
